export const surveyRoutes = {
  list: "",
  details: ":id",
  new: "new",
  edit: ":id/edit",
  respond: ":id/respond",
  fah: "feeling-at-home",
} as const;
